$(function(){
  setInterval(function(){
    console.clear();
  }, 100);
  
  $('.l-headerDrawerDk').mouseleave(function (e) {
    $(this).removeClass('is-open');
    $(this).addClass('l-hidden');
    $('html').removeClass('js-block-page');
    $('#header').removeClass('is-colored-mode').addClass('is-transparent-mode');
    $('.l-headerBanner').addClass('l-hidden');
  });

  $(document).mouseleave(function (e) {
    $('.l-headerDrawerDk').removeClass('is-open');
    $('.l-headerDrawerDk').addClass('l-hidden');
    $('html').removeClass('js-block-page');
    $('#header').removeClass('is-colored-mode').addClass('is-transparent-mode');
    $('.l-headerBanner').addClass('l-hidden');
  });

  $('.l-header__menu-item:not([data-lv1-link])').hover(function(){
    $('.l-headerDrawerDk').removeClass('is-open');
    $('.l-headerDrawerDk').addClass('l-hidden');
    $('html').removeClass('js-block-page');
  });

  $('.l-headerDrawerDk__link--lv2').hover(function(){
    $('.l-headerBanner').addClass('l-hidden');
    var x = $(this).data('lv2-link');
    $('.l-headerBanner[data-banner='+x+']').removeClass('l-hidden');
  });

  $('.l-productCard__cta-s1').click(function(){
    $(this).parent().find('.l-productCard__cta-qty').css('display', 'grid');
    $(this).hide();
  });
  $('l-product-card').mouseleave(function() {
    $(this).find('.l-productCard__cta-qty').hide();
    $(this).find('.l-productCard__cta-s1').show();
    $(this).find('.quantity-selector__input').val(1);
  });

  $('.l-mwt__tab').hover(function(){
    $('.l-mwt__picture').removeClass('active');
    let text = $(this).attr('id');
    let id= text.replace('tab', 'media');
    $('#'+id).addClass('active');
  });

  $('.l-headerDrawerMb__close').click(function(){
    $('.l-headerDrawerMb__menu--lv1').removeClass('l-hidden');
    $('.l-headerDrawerMb__menu--lv2').addClass('l-hidden');
    $('.l-headerDrawerMb__menu--lv3').addClass('l-hidden');
  });
  $(document).mouseup(function (e) {
    if ($(e.target).closest(".l-headerDrawerMb__card").length=== 0) {
      $('.l-headerDrawerMb__menu--lv1').removeClass('l-hidden');
      $('.l-headerDrawerMb__menu--lv2').addClass('l-hidden');
      $('.l-headerDrawerMb__menu--lv3').addClass('l-hidden');
    }
  });

  if($(window).width() < 700){
    $('.collection-toolbar__layout-switch-list .collection-toolbar__button[value="medium"]').trigger('click');
  }

  $('.collection-toolbar__button').click(function(){
    setTimeout(function(){
    var h1 = $('.product-list .l-productCard:first-child .l-productCard__media').innerHeight();
    var h2 = $('.product-list .l-productCard:first-child .l-productCard__content').innerHeight();
    $('.product-list .l-main-collection__card').height(h1+h2+1.5);
    $('.l-main-collection__card-picture').css('padding-top', h1+h2+1.5);
    }, 500);
  });

  // Disable alt, title, and aria-label tooltips
  const tooltipElements = document.querySelectorAll('[title]');
  const altElements = document.querySelectorAll('[alt]');
  const labelElements = document.querySelectorAll('[aria-label]');
  tooltipElements.forEach(element => {
  	element.addEventListener('mouseover', function () {
  		this.removeAttribute('title');
  	});
  });
  altElements.forEach(element => {
  	element.addEventListener('mouseover', function () {
  		this.removeAttribute('alt');
  	});
  });
  labelElements.forEach(element => {
  	element.addEventListener('mouseover', function () {
  		this.removeAttribute('aria-label');
  	});
  });
  ///////////////////////////////////////
});

$(document).ready(function(){
  var h1 = $('.product-list .l-productCard:first-child .l-productCard__media').innerHeight();
  var h2 = $('.product-list .l-productCard:first-child .l-productCard__content').innerHeight();
  $('.product-list .l-main-collection__card').height(h1+h2+1.5);
  $('.l-main-collection__card-picture').css('padding-top', h1+h2+1.5);
});

$(window).resize(function(){
  var h1 = $('.product-list .l-productCard:first-child .l-productCard__media').innerHeight();
  var h2 = $('.product-list .l-productCard:first-child .l-productCard__content').innerHeight();
  $('.product-list .l-main-collection__card').height(h1+h2+1.5);
  $('.l-main-collection__card-picture').css('padding-top', h1+h2+1.5);
});